import type {
	SRT_ColumnDef,
	SRT_RowData,
	SRT_StatefulTableOptions,
} from '../../types'

import { defaultDisplayColumnProps } from '../../utils/displayColumn.utils'

export const getSRT_RowNumbersColumnDef = <TData extends SRT_RowData>(
	tableOptions: SRT_StatefulTableOptions<TData>
): SRT_ColumnDef<TData> => {
	const { localization, rowNumberDisplayMode } = tableOptions
	const {
		pagination: { pageIndex, pageSize },
	} = tableOptions.state

	return {
		Cell: ({ row, staticRowIndex }) =>
			((rowNumberDisplayMode === 'static'
				? (staticRowIndex || 0) + (pageSize || 0) * (pageIndex || 0)
				: row.index) ?? 0) + 1,
		Header: () => localization.rowNumber,
		grow: false,
		...defaultDisplayColumnProps({
			header: 'rowNumbers',
			id: 'srt-row-numbers',
			size: 50,
			tableOptions,
		}),
	}
}
